import React from 'react';
import { Box } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TimelineIcon from '@mui/icons-material/Timeline';
import SectionTitle from '../shared/SectionTitle';
import InfoCard from '../shared/InfoCard';
import { t } from '../../../../utils/textUtils';
import { formatDate } from '../utils/formatters';
import { DETAIL_GRID_SX } from '../utils/constants';

const ScheduleTab = ({ project }) => (
  <>
    <SectionTitle
      title={t('JADWAL & TIMELINE')}
      subtitle={t('Tanggal penting untuk pelaksanaan proyek.')}
    />

    <Box sx={DETAIL_GRID_SX}>
      <InfoCard
        label={t('TANGGAL MULAI')}
        value={formatDate(project.startDate)}
        icon={<CalendarTodayIcon sx={{ color: '#6366F1' }} />}
      />
      <InfoCard
        label={t('TANGGAL SELESAI')}
        value={formatDate(project.estimatedEndDate)}
        icon={<CalendarTodayIcon sx={{ color: '#6366F1' }} />}
      />
      <InfoCard
        label={t('DURASI')}
        value={project.durasiProyek ? `${project.durasiProyek} ${t('HARI')}` : t('BELUM DIHITUNG')}
        icon={<TimelineIcon sx={{ color: '#14B8A6' }} />}
      />
    </Box>
  </>
);

export default ScheduleTab;
